"use client";

import { c as _c } from "react/compiler-runtime";
import { Star, StarHalf } from "lucide-react";
type RatingProps = {
  rating: number;
  outOf?: number;
  size?: number;
};
export const Rating = t0 => {
  const $ = _c(20);
  const {
    rating,
    outOf: t1,
    size: t2
  } = t0;
  const outOf = t1 === undefined ? 5 : t1;
  const size = t2 === undefined ? 14 : t2;
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = outOf - fullStars - (hasHalfStar ? 1 : 0);
  let t3;
  if ($[0] !== fullStars) {
    t3 = Array.from({
      length: fullStars
    }).map(_temp);
    $[0] = fullStars;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== hasHalfStar || $[3] !== size) {
    t4 = hasHalfStar && <StarHalf size={size} className="fill-yellow-400 text-yellow-400" />;
    $[2] = hasHalfStar;
    $[3] = size;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== emptyStars) {
    t5 = Array.from({
      length: emptyStars
    });
    $[5] = emptyStars;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== size || $[8] !== t5) {
    t6 = t5.map((__0, i_0) => <Star key={`empty-${i_0}`} size={size} className="text-gray-300" />);
    $[7] = size;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== rating) {
    t7 = rating.toFixed(1);
    $[10] = rating;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== outOf || $[13] !== t7) {
    t8 = <span className="ml-1 text-xs font-bold">{t7}/{outOf}</span>;
    $[12] = outOf;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t6 || $[18] !== t8) {
    t9 = <div className="flex items-center gap-1">{t3}{t4}{t6}{t8}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
function _temp(_, i) {
  return <Star key={i} size={14} className="text-yellow-400" fill="currentColor" />;
}